import { render, staticRenderFns } from "./PBDLateralMenu.vue?vue&type=template&id=36033ad2&scoped=true&"
import script from "./PBDLateralMenu.vue?vue&type=script&lang=js&"
export * from "./PBDLateralMenu.vue?vue&type=script&lang=js&"
import style0 from "./PBDLateralMenu.vue?vue&type=style&index=0&id=36033ad2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36033ad2",
  null
  
)

export default component.exports